import Node from 'ln/node/Node';
import Template from 'ln/template/TemplateManager';
import View from 'ln/view/View';
import type AudioTipModel from './AudioTipModel';

export default class AudioTip extends View {

    data:AudioTipModel;

    private audioElement:HTMLAudioElement;

    constructor( data:AudioTipModel, template?:string ) {
        super( data );
        this.defaultTemplate = template ?? 'lm.audio-tooltip-tip';
    }

    init() {
        this.node.click.add( () => this.togglePlaying() );
        this.data.change.add( () => this.onPlayingChanged() );

        this.audioElement = <HTMLAudioElement> this.node.js( 'audio' ).native;
        this.audioElement.addEventListener( 'ended', () => this.data.playing = false );
    }

    private togglePlaying() {
        this.data.playing = !this.data.playing;
    }

    private onPlayingChanged() {
        this.node.toggleClass( '-playing', this.data.playing );

        const iconNode = this.node.js( 'icon' );
        iconNode.replace( Node.fromHTML( Template.render( 'lm.audio-tooltip-tip-icon', this.data ) ) );

        if( this.data.playing ) {
            this.audioElement.currentTime = 0;
            this.audioElement.play();
        }
        else {
            this.audioElement.pause();
        }
    }
}
